/*=============================================== Avatar ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
import FajnyIcon from "./FajnyIcon";
import Icon from "./Icon";
import Image from "./Image";
/*==================== Component ====================*/
var Avatar = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "xxl" : _c, src = _a.src, _d = _a.alt, alt = _d === void 0 ? "Avatar" : _d, children = _a.children, icon = _a.icon, fajnyIcon = _a.fajnyIcon, props = __rest(_a, ["color", "size", "src", "alt", "children", "icon", "fajnyIcon"]);
    var iconSize = size === "xxl"
        ? 48
        : size === "xl"
            ? 40
            : size === "l"
                ? 32
                : size === "m"
                    ? 24
                    : size === "s"
                        ? 16
                        : size === "xs"
                            ? 12
                            : 8;
    return (React.createElement(Container, __assign({ "$color": color, "$size": size }, props),
        src && React.createElement(Image, { src: src, alt: alt, width: "100%", height: "100%", fit: "cover" }),
        icon && React.createElement(Icon, { src: icon, size: iconSize }),
        fajnyIcon && React.createElement(FajnyIcon, { name: fajnyIcon, size: iconSize }),
        children && children));
};
export default Avatar;
/*==================== Styles ====================*/
var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", "px;\n    ", ";\n    overflow: hidden;\n"], ["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: ", ";\n    font-size: ", "px;\n    ", ";\n    overflow: hidden;\n"])), function (_a) {
    var $size = _a.$size;
    return $size === "xxl"
        ? 64
        : $size === "xl"
            ? 56
            : $size === "l"
                ? 48
                : $size === "m"
                    ? 40
                    : $size === "s"
                        ? 32
                        : $size === "xs"
                            ? 24
                            : 16;
}, function (_a) {
    var $size = _a.$size;
    return $size === "xxl"
        ? 64
        : $size === "xl"
            ? 56
            : $size === "l"
                ? 48
                : $size === "m"
                    ? 40
                    : $size === "s"
                        ? 32
                        : $size === "xs"
                            ? 24
                            : 16;
}, Variables.Radiuses.Circle, Mixins.ColorsShort, function (_a) {
    var $color = _a.$color;
    return ($color === "white" ? Variables.Colors.Primary500 : Variables.Colors.White);
}, Variables.FontWeights.Black, function (_a) {
    var $size = _a.$size;
    return $size === "xxl"
        ? 64 * 0.6
        : $size === "xl"
            ? 56 * 0.6
            : $size === "l"
                ? 48 * 0.6
                : $size === "m"
                    ? 40 * 0.6
                    : $size === "s"
                        ? 32 * 0.6
                        : $size === "xs"
                            ? 24 * 0.6
                            : 16 * 0.6;
}, Mixins.Flexbox({
    $align: "center",
    $justify: "center",
    $inline: true,
}));
var templateObject_1;
